import React from "react";
import { Box } from "@mui/material";
import CustomSkeleton from "../../../../components/custom-skeleton/CustomSkeleton";

const UltrasoundCustomSkeleton: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "400px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        justifyContent: "center",
      }}
    >
      <Box pt={4} pb={1} display="flex" justifyContent="center">
        <CustomSkeleton variant="rectangular" width={120} height={120} />
      </Box>
      <CustomSkeleton variant="text" width="90%" height={20} />
      <CustomSkeleton variant="text" width="90%" height={30} />
    </Box>
  );
};

export default UltrasoundCustomSkeleton;

